<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-va-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-va-badge">Valamar App</span>

  <div class="cr-va-row">
    <div
      class="cr-va-dropzone"
      [appInlineMedia]="block.variables?.['AppImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'AppImage')"
    >
      <a *ngIf="block.variables?.['AppImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['AppImage']" [alt]="block.variables?.['AppImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-va-content">
      <span
        class="cr-va-heading"
        [appInlineEdit]="block.variables?.AppHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'AppHeading')"
      ></span>

      <span
        class="cr-va-text"
        [appInlineEdit]="block.variables?.AppText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'AppText')"
      ></span>

      <div class="cr-va-store-row">
        <a class="cr-va-store-link" [href]="cta1Href" target="_blank" rel="noopener">Google Play</a>
        <a class="cr-va-store-link" [href]="cta2Href" target="_blank" rel="noopener">App Store</a>
      </div>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-va-edit" *ngIf="!isPreview">
  <div class="cr-va-field-row">
    <span class="cr-va-field-label">Image</span>
    <span
      class="cr-va-toggle"
      [class.cr-va-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-va-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['AppImage'] ?? ''"
      (handleOnChange)="onChange($event, 'AppImage')"
      [placeholder]="imagePlaceholder"
      variable="AppImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-va-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['AppImage']">
      <div class="cr-va-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-va-title">Upload image</div>
      <div class="cr-va-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-va-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['AppImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'AppImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="AppImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'AppImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['AppImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['AppImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'AppImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="AppImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['AppHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'AppHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="AppHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['AppText'] ?? ''"
    (handleOnChange)="onChange($event, 'AppText')"
    [placeholder]="textPlaceholder"
    [maxLength]="500"
    variable="AppText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-va-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['AppCta1Link'] ?? ''"
      (handleOnChange)="onChange($event, 'AppCta1Link')"
      [placeholder]="ctaLink1Placeholder"
      [maxLength]="500"
      variable="AppCta1Link"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'AppCta1LinkSegmentRegex')"
      [selectedSegment]="block.variables?.['AppCta1LinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-va-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['AppCta2Link'] ?? ''"
      (handleOnChange)="onChange($event, 'AppCta2Link')"
      [placeholder]="ctaLink2Placeholder"
      [maxLength]="500"
      variable="AppCta2Link"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'AppCta2LinkSegmentRegex')"
      [selectedSegment]="block.variables?.['AppCta2LinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
